var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentBox"},_vm._l((_vm.imgs),function(img,index){return _c('div',{key:index,staticClass:"contentBlock fade-in-section"},[_c('img',{attrs:{"src":img}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }